// extracted by mini-css-extract-plugin
export default {"SkeletonSearchForm":"SkeletonSearchForm_SkeletonSearchForm__Fj1T7","skeleton-search-control-item":"SkeletonSearchForm_skeleton-search-control-item__Z8upY"};